
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom"; // ADDED: useLocation import
import placeholderLocationPic from "../img/school.png";
import * as FaIcons from "react-icons/fa";
import RegistrationContext from "../context/registration/registrationContext";
import { useContext } from "react";
import findBrand from "./findBrand.js";
import { brandDomains, fetchBrands } from "./brand.js";
// import UserContext from "../context/users/userContext.js";
import capitalizeFirstLetter from "../helpers/general";
import LoadingOverlay from "./utilities/LoadingOverlay"; // ADDED: Import LoadingOverlay
import phoneicon from ".././img/phoneicon.png";
import InterestContext from "../context/interest/interestContext";

const ButtonContainer = ({ site }) => {
  const registrationContext = useContext(RegistrationContext);
  const {
    id,
    name,
    charter,
    photo,
    coordinates,
    distance,
    address: {
      state,
      start_day,
      end_day,
      start_time,
      end_time,
      address_1,
      city,
      phone,
      zip,
    },
  } = site;
  useEffect(() => {
    const loadBrands = async () => {
      await fetchBrands();
    };

    loadBrands();
  }, []);

  //console.log("brands", brandDomains);

  const brand_holston = brandDomains.brand_holston?.name;
  const brand_pbia = brandDomains.brand_pbia?.name;
  const brand_learn4life = brandDomains.brand_learn4life?.name;
  const brand_flexhigh = brandDomains.brand_flexhigh?.name;
  const brand_elev8schools = brandDomains.brand_elev8?.name;
  const brand_llac = brandDomains.brand_llac?.name;

  return (
    <div
      id={`site-${id}`}
      className="footer-buttons"
      onClick={() => {
        document
          .getElementById(`site-${id}`)
          .scrollIntoView({ behavior: "smooth" });
      }}
    >
      <Link
        to={`/interest?site=${id}`}
        onClick={() => {}}
        className={
          findBrand(brand_learn4life)
            ? "action-button inforKitLearn4Life"
            : findBrand(brand_holston)
            ? "action-button inforKitHolston"
            : findBrand(brand_elev8schools)
            ? "action-button inforKitElev8"
            : findBrand(brand_flexhigh)
            ? "action-button inforKitFlex"
            : findBrand(brand_pbia)
            ? "action-button inforKitPIA"
            : findBrand(brand_llac)
            ? "action-button inforKitllac"
            : "action-button none"
        }
      >
        Request Info Kit
      </Link>

      {site.enrollment_info.secondaryEnrollmentUrl && (
        <a
          href={site.enrollment_info.secondaryEnrollmentUrl}
          className="action-button inforKitllac"
        >
          Expanded Learning Registration
        </a>
      )}


      <Link
        to={`/register?site=${id}`}
        onClick={() => {}}
        className={
          findBrand(brand_holston)
            ? "action-button enrollNowHolston"
             ://  findBrand(brand_learn4life)
            //  ? "action-button enrollNowLearn4Life"
             //: findBrand(brand_elev8schools)
            // ? "action-button enrollNowElev8"
            // : findBrand(brand_flexhigh)
            // ? "action-button enrollNowFlex"
            findBrand(brand_pbia)
            ? "action-button enrollNowPIA"
            : "action-button none"
        }
      >
        Enroll Now
      </Link>
    </div>
  );
};

const InformationDisplay = ({ data }) => {
  // ADDED: Hook to get current URL
  const location = useLocation();
  // const userContext = useContext(UserContext);
  // const { programTypes, getProgramTypes } = userContext;
   const interestContext = useContext(InterestContext);
  const { programTypesforweb,getProgramtypesforweb } = interestContext;

  // ADDED: State to track current site ID and data readiness
  const [currentSiteId, setCurrentSiteId] = useState(null);
  const [isDataReady, setIsDataReady] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // ADDED: Loading state
  const [imageSrc, setImageSrc] = useState(placeholderLocationPic);

  // ADDED: Get site ID from URL parameters
  const urlParams = new URLSearchParams(location.search);
  const siteIdFromUrl = urlParams.get("site");

  // ADDED: Effect to handle site ID changes and data validation
  useEffect(() => {
    // If site ID changed, reset data readiness immediately
    if (currentSiteId !== siteIdFromUrl) {
      setIsDataReady(false);
      setIsLoading(true);
      setCurrentSiteId(siteIdFromUrl);
      // getProgramTypes();
      getProgramtypesforweb();
    }

    // Check if data matches current site ID and is complete
    if (
      data &&
      Object.keys(data).length > 0 &&
      data.displayName &&
      data.charter &&
      data.id &&
      data.id.toString() === siteIdFromUrl
    ) {
      setIsDataReady(true);
      setIsLoading(false); // ADDED: Set loading to false when data is ready
    } else if (
      siteIdFromUrl &&
      data &&
      data.id &&
      data.id.toString() !== siteIdFromUrl
    ) {
      // Data is for different site, keep loading
      setIsDataReady(false);
      setIsLoading(true); // ADDED: Set loading to true when data is ready
    }
  }, [data, siteIdFromUrl, currentSiteId]);

  // Update image src when photo changes
  useEffect(() => {
    if (data && data.photo) {
      // Try to load the image first to check if it exists
      const img = new Image();
      img.onload = () => {
        setImageSrc(data.photo);
      };
      img.onerror = () => {
        setImageSrc(placeholderLocationPic);
      };
      img.src = data.photo;
    } else {
      setImageSrc(placeholderLocationPic);
    }
  }, [data?.photo]);

  // MODIFIED: Updated existing useEffect to depend on isDataReady
  useEffect(() => {
    if (isDataReady && data.charter?.brandIcon) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
      }
      link.href = data.charter.brandIcon;
    }

    // Scroll to the top when the component mounts
    window.scrollTo(0, 0);
  }, [isDataReady, data.charter?.brandIcon]);

  // ADDED: Early return to prevent showing wrong data - no loading message
  if (!isDataReady || !siteIdFromUrl || isLoading) {
    // return null; // Don't render anything until correct data is ready
    return <LoadingOverlay isLoading={true} />;
  }
const getPrimaryAddress = () => {
  //console.log("Addresses field:", data.addresses); 
  if (data.addresses && data.addresses.length > 0) {
    const primaryAddr = data.addresses.find((addr) => addr.isPrimary) || data.addresses[0];
    //console.log("Primary Address:", primaryAddr); 
    return {
      state: primaryAddr.state,
      address_1: primaryAddr.street || primaryAddr.address_1, 
      address_2: primaryAddr.address_2 || '', 
      city: primaryAddr.city,
      phone: primaryAddr.phone || data.address?.phone || '', 
      fax: primaryAddr.fax || '', 
      zip: primaryAddr.zip,
      start_day: primaryAddr.start_day || '',
      end_day: primaryAddr.end_day || '',
      start_time: primaryAddr.start_time || '',
      end_time: primaryAddr.end_time || '',
      description: primaryAddr.description || '',
    };
  }
  //console.log("Fallback to legacy address:", data.address); 
  return {
    state: data.address?.state || '',
    address_1: data.address?.address_1 || '',
    address_2: data.address?.address_2 || '',
    city: data.address?.city || '',
    phone: data.address?.phone || '',
    fax: data.address?.fax || '',
    zip: data.address?.zip || '',
    start_day: data.address?.start_day || '',
    end_day: data.address?.end_day || '',
    start_time: data.address?.start_time || '',
    end_time: data.address?.end_time || '',
    description: data.address?.description || '',
  };
};
  const {
    displayName,
    charter,
    photo,
  } = data;
  
  const {
    state,
    address_1,
    address_2,
    fax,
    city,
    phone,
    zip,
    start_day,
    end_day,
    start_time,
    end_time,
    description,
  } = getPrimaryAddress();

  const address = `${address_1}, ${city}, ${state}, ${zip}`;
  const isLocationPicEmpty = photo === "";

  // ADDED: Get brand name from charter data
  const brandName = charter?.brandName || charter?.name || "";

  // ADDED: Program click handler
  const handleProgramClick = (program) => {
    if (program.url) {
      window.open(program.url, "_blank");
    }
  };

  const getFilteredPrograms = () => {
    // Make sure programTypes is an array
    if (!Array.isArray(programTypesforweb) || programTypesforweb.length === 0) return [];

    const programMap = {
      "Career Technical Education": {
        displayName: "CTE",
        icon: (
          <img src="https://locationsappstorage.blob.core.windows.net/icons/cte.webp" />
        ),
        className: "cte-icon",
        order: 1,
      },
      "CLMI Fellowship": {
        displayName: "CLMI",
        icon: (
          <img src="https://locationsappstorage.blob.core.windows.net/icons/clmi.webp" />
        ),
        className: "clmi-icon",
        order: 2,
      },
      WIOA: {
        displayName: "WIOA",
        icon: (
          <img src="https://locationsappstorage.blob.core.windows.net/icons/wioa.svg" />
        ),
        className: "wioa-icon",
        order: 3,
      },
      HOPE: {
        displayName: "HOPE",
        icon: (
          <img src="https://locationsappstorage.blob.core.windows.net/icons/hope.svg" />
        ),
        className: "hope-icon",
        order: 4,
      },
    };

    const desiredOrder = [
      "Career Technical Education",
      "CLMI Fellowship",
      "WIOA",
      "HOPE",
    ];

    return desiredOrder
      .map((programName) => {
        const program = programTypesforweb.find((p) => p.name === programName);
        if (program && programMap[program.name]) {
          // Check if program has brand information and if it matches the current brand (case-insensitive)
          const programBrand =
            program.brand && program.brand[0] && program.brand[0].brandName;
          const shouldShowProgram =
            programBrand &&
            brandName &&
            programBrand.toLowerCase() === brandName.toLowerCase();

          if (shouldShowProgram) {
            return {
              ...program,
              ...programMap[program.name],
              url: program.brand[0].url || null,
            };
          }
        }
        return null;
      })
      .filter((program) => program !== null);
  };

  const filteredPrograms = getFilteredPrograms();
  const hasPrograms = filteredPrograms.length > 0;

  return (
    <>
      
      {/* <div className="brand-hero">
        <div className="container">
          <p className="text-center">
            Thank you for your interest in our school!
          </p>
          <h2 className="text-center">Learn More About Our Programs</h2>
          <ButtonContainer site={data} />
        </div>
      </div> */}
      {/* Learn4Life Hero Section - Add above everything for Learn4Life brand */}
      {brandName && brandName.toLowerCase() === 'learn4life' && (
        <div className="learn4life-site-hero">
          <div className="hero-content">
            <h3 className="learning-center-name">{charter?.name}</h3>
          </div>
        </div>
      )}

      {brandName && brandName.toLowerCase() === 'learn4life' && (
        <div className="l4l-hero-spacing"> </div>
      )}

      <div className={`container-wrapper ${brandName && brandName.toLowerCase() === 'learn4life' ? 'with-hero-spacing' : ''}`}>
        <div className="content-card">
          {/* Content Section */}
          <div className="content-grid">
            {/* Top Row with space-between layout */}
            <div className="top-row">
              {/* Large Image Container */}
              <div className={`large-image-container ${brandName && brandName.toLowerCase() === 'learn4life' ? 'l4l' : 'nol4l'}`}>
                <img
                  src={imageSrc}
                  alt="School Image"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = placeholderLocationPic;
                  }}
                />
              </div>

              {/* Contact Info and Programs Section - right side */}
              <div className="contact-programs-section">
              {/* Contact Info Section */}
              <div className="contact-info-section">
                <div>
                  <h3 className="section-title">Address:</h3>
                  <p className="section-text"> {address_1},</p>
                  <p className="section-text">{city},</p>
                  <p className="section-text">
                    {state}, {zip}
                  </p>
                </div>

                <div>
                  <h3 className="section-title">Hours:</h3>
                  <p className="section-text">{`${capitalizeFirstLetter(
                    start_day
                  )} - ${capitalizeFirstLetter(end_day)} from `}</p>
                  <p className="section-text">{`${start_time} - ${end_time}`}</p>
                </div>

                <div className="phone-link">
                  {phone !== "" && (
                    <a
                      href={`tel:+${phone}`}
                      className=".section-text.font-medium"
                    >
                      <img
                        src={phoneicon}
                        alt="Phone"
                        className="phone-icon"
                      />{" "}
                      {phone}
                    </a>
                  )}
                </div>
              </div>

              {/* Programs Section - on right side below contact info */}
              {hasPrograms && (
                <div className="programs-section">
                  <div>
                    <h3 className="section-title">Programs</h3>
                    <div className="programs-container">
                      {filteredPrograms.map((program) => (
                        <div
                          key={program._id}
                          className="program-item-info"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleProgramClick(program);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <div className={`program-circle ${program.className}`}>
                            {program.icon}
                          </div>
                          <span className="program-text">
                            {program.displayName}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              </div>
            </div>

         
            {data.enrollment_info && data.enrollment_info.about && data.enrollment_info.about.trim() !== '' && (
              <div className="full-width-description">
                <div className="description-section">

                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.enrollment_info.about
                        // First convert image URLs to img tags (BEFORE converting other URLs to links)
                        .replace(/\b(https?:\/\/[^\s<>"]+\.(jpg|jpeg|png|gif|webp|svg|bmp|tiff))\b/gi, '<img src="$1" alt="Image" />')
                        // Make phone numbers clickable (but avoid if already inside tags)
                        .replace(/(?<!href=["'][^"']*)\b(\d{3}[-.\s]?\d{3}[-.\s]?\d{4})\b(?![^<]*[">])/g, '<a href="tel:$1">$1</a>')
                        // Make URLs clickable (but avoid if already inside HTML tags like img src)
                        .replace(/(?<!(?:src|href)=["'][^"']*)\b(https?:\/\/[^\s"<>]+)\b(?![^<]*\/>)(?![^<]*<\/a>)/gi, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>')
                        // Make www URLs clickable (but avoid if already inside HTML tags)
                        .replace(/(?<!(?:src|href)=["'][^"']*)\b(www\.[^\s"<>]+)\b(?![^<]*\/>)(?![^<]*<\/a>)/gi, '<a href="https://$1" target="_blank" rel="noopener noreferrer">$1</a>')
                    }}
                  />
                </div>
              </div>
            )}
           </div> 

        {/* More About Us Section - Only for Learn4Life brand */}
        {data.enrollment_info && data.enrollment_info.moreAbout && data.enrollment_info.moreAbout.trim() !== '' && (
          <div className="more-about-us-section">
            <h3>More About Us</h3>
            <div className="more-about-us-content">
              <div
                dangerouslySetInnerHTML={{
                  __html: data.enrollment_info.moreAbout
                    // First convert image URLs to img tags (BEFORE converting other URLs to links)
                    .replace(/\b(https?:\/\/[^\s<>"]+\.(jpg|jpeg|png|gif|webp|svg|bmp|tiff))\b/gi, '<img src="$1" alt="Image" />')
                    // Make phone numbers clickable (but avoid if already inside tags)
                    .replace(/(?<!href=["'][^"']*)\b(\d{3}[-.\s]?\d{3}[-.\s]?\d{4})\b(?![^<]*[">])/g, '<a href="tel:$1">$1</a>')
                    // Make URLs clickable (but avoid if already inside HTML tags like img src)
                    .replace(/(?<!(?:src|href)=["'][^"']*)\b(https?:\/\/[^\s"<>]+)\b(?![^<]*\/>)(?![^<]*<\/a>)/gi, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>')
                    // Make www URLs clickable (but avoid if already inside HTML tags)
                    .replace(/(?<!(?:src|href)=["'][^"']*)\b(www\.[^\s"<>]+)\b(?![^<]*\/>)(?![^<]*<\/a>)/gi, '<a href="https://$1" target="_blank" rel="noopener noreferrer">$1</a>')
                }}
              />
            </div>
          </div>
        )}

        <ButtonContainer site={data} />
      </div>
    </div>
      {brandName && brandName.toLowerCase() === 'learn4life' && (
        <div className="l4l-overlay-section">
          <div className="overlay-content">
            <p>
              Our students love attending our schools because at
              Learn4Life, you are in control. Thinking about
              enrolling? This is what you can expect when you walk through our
              doors.
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default InformationDisplay;